// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".read-more-link[data-v-73222e13] {\n  color: #62BCFC;\n  cursor: pointer;\n  margin-top: 5px;\n}\n.read-more-link[data-v-73222e13]:hover {\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
